import React from "react";
import {
  FaEnvelope,
  FaGithub,
  FaLinkedin,
  FaStackOverflow,
} from "react-icons/fa";
import "./Footer.scss";

const Footer = () => {
  return (
    <div id="footer">
      <p>© 2022. All rights reserved to Thorya Aadland.</p>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="mailto:thoryagudrun@gmail.com"
        alt="email link"
      >
        <FaEnvelope />
        <p className="invisible_txt">My Email</p>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.linkedin.com/in/thorya-aadland/"
        alt="LinkedIn Link"
      >
        <FaLinkedin />
        <p className="invisible_txt">My LinkedIn</p>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://stackoverflow.com/users/9457623/"
        alt="Stack Overflow Link"
      >
        <FaStackOverflow />
        <p className="invisible_txt">My StackOverFlow</p>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://github.com/ZontarZon"
        alt="Git Hub Link"
      >
        <FaGithub />
        <p className="invisible_txt">My GitHub</p>
      </a>
    </div>
  );
};

export default Footer;
